(function() {

	angular
		.module('ngmvac')
		.factory('AutoFactory', AutoFactory);

	AutoFactory.$inject = ['$http'];

	function AutoFactory($http) {
		var tipoConsulta;
		return {
			get 			: get,
			setTipo 		: setTipo,
			getHoras 		: getHoras,
			sessionStore 	: sessionStore,
			getAuto 		: getAuto,
			save			: save
		}

		function get(params) {
			params.params.tipo = tipoConsulta;
			return $http.get('/hotel/flota', params);
		}

		function setTipo(tipo) {
			tipoConsulta = tipo;
		}

		function getHoras(){
			return $http.get('/horas.json');
		}

		function sessionStore(params){
			return $http.post('/auto/store', params);
		}
		function getAuto(params){
			return $http.get('/auto/data');
		}
		function save(params){
			return $http.post('/auto/save', params);
		}
	}

})();
